import { useEffect, useState } from 'react';
import { UiText } from 'znanie-uikit';

import { calculateTime } from 'utils/timer/calculateTime';

import css from './EventTimer.module.scss';

interface IProps {
  value: string;
}

export function EventTimer({ value }: IProps) {
  const [timerDays, setTimerDays] = useState(0);
  const [timerHours, setTimerHours] = useState(0);
  const [timerMinutes, setTimerMinutes] = useState(0);

  let interval: NodeJS.Timeout;

  const startTimer = () => {
    const updateTimeStates = () => {
      if (!value) return;

      const { timeDifference, days, hours, minutes } = calculateTime(value);

      if (timeDifference < 0) {
        clearInterval(interval);
      } else {
        setTimerDays(days);
        setTimerHours(hours);
        setTimerMinutes(minutes);
      }
    };

    interval = setInterval(() => {
      updateTimeStates();
    }, 1000);
  };

  useEffect(() => {
    startTimer();

    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <div className={css.timerBlock}>
      <UiText size="small" color="grey" align="center">
        Осталось до начала трансляции
      </UiText>
      <div className={css.timerList}>
        <div className={css.timerItem}>
          <span className={css.timerValue}>{timerDays}</span>
          <span className={css.timerUnit}>дней</span>
        </div>

        <div className={css.timerItem}>
          <span className={css.timerValue}>{timerHours}</span>
          <span className={css.timerUnit}>часов</span>
        </div>

        <div className={css.timerItem}>
          <span className={css.timerValue}>{timerMinutes}</span>
          <span className={css.timerUnit}>минут</span>
        </div>
      </div>
    </div>
  );
}
